import { Component } from '@angular/core';

@Component({
  selector: 'app-report-operations',
  templateUrl: './report-operations.component.html',
  styleUrls: ['./report-operations.component.scss']
})
export class ReportOperationsComponent {
  tab = 3;
}
